export function classicChatEmptyState(assistantName: string): string {
  return `Sag oder schreib deine Mission. ${assistantName} plant, arbeitet und zeigt Gates/Evidence im Verlauf.`;
}

export function classicChatMissionPlaceholder(assistantName: string): string {
  return `Sag oder schreib deine Mission fuer ${assistantName}. Beispiel: Bring SimoT auf Stand und pruefe die Gates.`;
}

export function classicChatVoiceDeviceDetail(input: {
  canSelectMic: boolean;
  devices: number;
  selectedDeviceLabel?: string;
}): string {
  if (!input.canSelectMic) return "Mic-Freigabe pruefen, dann werden Geraete angezeigt.";
  const deviceLabel = input.selectedDeviceLabel?.trim() || "Standard-Mic";
  return `${deviceLabel} · ${input.devices} Geraet${input.devices === 1 ? "" : "e"} erkannt`;
}
